import { ActionIcon, Box, Group, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconMenu2 } from '@tabler/icons-react';
import { Link, useRouterState } from '@tanstack/react-router';
import { BrandLogo } from '~portal/components/BrandLogo';
import { ColorSchemeToggle } from '~portal/components/ColorSchemeToggle';
import { Cmp } from '~portal/lib';
import { touchTarget } from '~portal/styles/touch-target.css';
import * as styles from './GlobalNav.css';
import { GlobalNavDrawer } from './GlobalNavDrawer';
import { currentSectionLabel } from './GlobalNavItems';

/**
 * @desc The slim header row the global nav collapses into below `md` (the Figma file has no
 * phone frames): the burger that opens `GlobalNavDrawer`, the logo, the current section's name
 * and the scheme control. The same shape as the chat route's own mobile sub-header, which the
 * chat layout keeps in place of this one.
 */
export const GlobalNavMobileHeader: Cmp = function () {
  const path = useRouterState({ select: (state) => state.location.pathname });
  const [opened, { open, close }] = useDisclosure(false);
  const label = currentSectionLabel(path);

  return (
    <>
      <Group
        hiddenFrom="md"
        className={styles.mobileHeader}
        gap="sm"
        wrap="nowrap"
        px="md"
        data-testid="global-nav-mobile-header"
      >
        <ActionIcon
          onClick={open}
          size="lg"
          variant="default"
          className={touchTarget}
          aria-label="Open navigation"
        >
          <IconMenu2 size={20} />
        </ActionIcon>
        <Link to="/" aria-label="H2GC home" className={styles.brandLink}>
          <BrandLogo height={28} />
        </Link>
        <Box flex={1} miw={0}>
          {label && (
            <Text size="sm" fw={500} className={styles.sectionLabel}>
              {label}
            </Text>
          )}
        </Box>
        <ColorSchemeToggle />
      </Group>
      <GlobalNavDrawer opened={opened} onClose={close} />
    </>
  );
};
